import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  initialize() {
    super.initialize();

    this.applyingDiscount = false;
  }

  async applyDiscount() {
    if (this.applyingDiscount) {
      return;
    }

    let coupon = this.element.querySelector('[name="coupon_code"]')?.value;
    if (!coupon) {
      return;
    }

    const data = new FormData();
    data.append('coupon_code', coupon);
    data.append('security', this.element.querySelector('[name="security"]')?.value);

    this.applyingDiscount = true;
    await fetch('/?wc-ajax=apply_coupon', {
      body: data,
      method: 'POST',
    })
      .then((response) => response.text())
      .then((content) => {
        if (content.indexOf('woocommerce-error') >= 0) {
          document.getElementById('coupon-error-outlet').textContent = new DOMParser().parseFromString(content, 'text/html').querySelector('.woocommerce-error').textContent;
        } else {
          jQuery('form.woocommerce-checkout').trigger('update');
        }

        this.applyingDiscount = false;
      })
      .catch((error) => {
        this.applyingDiscount = false;

        return Promise.reject(error);
      });
  }
}
